import { ListItem } from '@/common/components/SimpleSelector.tsx'

export const TABLE_FILTERS = [
  { id: 0, name: 'all_types' },
  { id: 1, name: 'School' },
  { id: 3, name: 'Teacher' },
  { id: 4, name: 'Shop' },
] as ListItem[]
